<template>
    <div class="container">
        <content-header title="Информация для пациентов"/>
        <p style="font-size: 18px; text-align: center;">
            <strong>
                Прием граждан руководителем медицинской организации, осуществляется <br>
                по предварительной записи, по телефонам: 8(495)620-81-32; 8(499)248-10-20<br>
                Адрес электронной почты: udz39@5-clinic.ru
            </strong>
        </p>
        <div class="divider"></div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Больничный-Пациентам.pdf" target="_blank"
               class="link left-30px">
                <span>
                    Больничный Пациентам
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Профилактика-гриппа-и-ОРВИ-в-осенний-период.pdf" target="_blank"
               class="link left-30px">
                <span>
                    Профилактика гриппа и ОРВИ в осенний период
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Правила-внутреннего-распорядка-ФГБУ-Поликлиника-№5.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Правила внутреннего распорядка ФГБУ «Поликлиника №5»
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Права-и-обязанности-граждан-с-сфере-охраны-здоровья.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Права и обязанности граждан в сфере охраны здоровья
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Общие-правила-предоставления-платных-медицинских-услуг.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Общие правила предоставления платных медицинских услуг
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/20-от-18.01.2021.pdf" target="_blank" class="link left-30px">
                <span>
                    Положение о платных медицинских услугах в Поликлинике №5
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Список-врачей-специалистов-для-сайта_по-состоянию-на-14.04.2022г.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Сведения о медицинских работниках
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Перечень-ЖНВЛ-препаратов-в-редакции-24.08.2022.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Перечень жизненно необходимых и важнейших лекарственных препаратов для медицинского применения
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Перечень-лекарственных-препаратов-предназначенных-для-обеспечения-лиц.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Перечень лекарственных препаратов, предназначенных для обеспечения лиц, больных гемофилией, муковисцидозом, гипофизарным нанизмом, болезнью Гоше
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Перечень-групп-населения-имеющие-право-на-бесплатное-лекарств-обеспечение.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Перечень групп населения и категории заболеваний, при амбулаторном лечении которых лекарственные средства и изделия медицинского назначения отпускаются по рецептам врачей бесплатно
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Перечень-групп-населения-имеющие-право-на-лекарств-обеспечение-с-50-скидкой.pdf"
               target="_blank"
               class="link left-30px">
                <span>
                    Перечень групп населения, при амбулаторном лечении которых лекарственные средства отпускаются по рецептам врачей с 50-процентной скидкой со свободных цен
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Критерии-доступности-и-качества-медицинской-помощи.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Критерии доступности и качества медицинской помощи.
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/О-диспансеризации.pdf" target="_blank" class="link left-30px">
                <span>
                    О диспансеризации
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/выдача-мед-документов-и-ознакомление-с-ней-35-от-17.02.2022.pdf"
               target="_blank" class="link left-30px">
                <span>
                    Положение о хранении медицинской карты пациента, получающего медицинскую помощь в амбулаторных условиях, основаниях, сроках и порядке предоставления медицинской карты (копий) и выписок, порядок ознакомления с медицинской документацией
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Приказ-43лс-от-11.02.2021.pdf" target="_blank"
               class="link left-30px">
                <span>
                    Приказ о назначении руководителя учреждения
                </span>
            </a>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <div>
                <a href="/static/files/staticContent/График-приема.pdf" target="_blank"
                   class="link left-30px">
                <span>
                    График личного приема граждан
                </span>
                </a>
                <p class="left-30px">
                    В целях защиты здоровья населения и обеспечения безопасности граждан в рамках
                    предупреждения распространения новой коронавирусной инфекции COVID -19 временно приостановлен личный
                    прием граждан в ФГБУ «Поликлиника № 5».<br>
                    При необходимости просим направлять письменные обращения по официальным каналам связи:<br>
                    по почте: 119121, г. Москва, ул. Плющиха, дом 14;<br>
                    по электронной почте: udz39@5-clinic.ru.<br>
                    О возобновлении личного приема граждан будет сообщено дополнительно
                </p>
            </div>
        </div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/Налоговые-льготы-по-затратам-на-лечение-1.pdf" target="_blank"
               class="link left-30px">
                <span>
                    Налоговые льготы по затратам на лечение
                </span>
            </a>
        </div>
        <div class="divider"></div>
        <p style="text-align: center;">
            <strong>ПРОГРАММА ГОСУДАРСТВЕННЫХ ГАРАНТИЙ БЕСПЛАТНОГО ОКАЗАНИЯ МЕДИЦИНСКОЙ ПОМОЩИ:</strong>
        </p>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                 width="75"/>
            <a href="/static/files/staticContent/терр-программа-ОМС-на-2022.pdf" target="_blank"
               class="link left-30px">
                <span>
                    О территориальной программе государственных гарантий бесплатного оказания гражданам медицинской помощи в городе Москве на 2022 год и на плановый период 2023 и 2024 годов
                </span>
            </a>
        </div>
        <div class="divider"></div>
        <p style="text-align: center">
            <strong>КОНТАКТНАЯ ИНФОРМАЦИЯ ДЛЯ ГРАЖДАН, ЗАСТРАХОВАННЫХ ПО ОМС:</strong>
        </p>
        <div style="text-align: center">
            <p><span class="bold">Департамент здравоохранения города Москвы</span> <br/>
                Адрес: 127006, г.Москва, Оружейный переулок, д.43 <br/>
                Телефон: 8(499)251-83-00 <br/>
                Сайт: <a href="https://mosgorzdrav.ru" class="link" target="_blank" style="display: inline-block">
                    <span>www.mosgorzdrav.ru</span></a>
            </p>
        </div>
        <div style="text-align: center">
            <p><span class="bold">Федеральный фонд обязательного медицинского страхования (ФОМС)</span> <br/>
                Адрес: 127994, г.Москва, ул.Новослободская, д.37, корп.4А <br/>
                Телефон: 8(499)973-31-86; 8(499)978-91-79 <br/>
                Сайт: <a href="http://www.ffoms.gov.ru" class="link" target="_blank" style="display: inline-block">
                    <span>www.ffoms.ru</span></a>
            </p>
        </div>
        <div style="text-align: center">
            <p><span class="bold">Московский городской фонд обязательного медицинского страхования (МГФОМС)</span> <br/>
                Адрес: 117152, г.Москва, Загородное шоссе, д.18А <br/>
                Телефон: 8(495)958-18-96; 8(495)952-93-21 <br/>
                Сайт: <a href="https://www.mgfoms.ru" class="link" target="_blank" style="display: inline-block">
                    <span>www.mgfoms.ru</span></a>
            </p>
        </div>
        <div class="divider"></div>
        <p style="text-align: center">
            <strong>КОНТРОЛИРУЮЩИЕ И НАДЗОРНЫЕ ОРГАНЫ:</strong>
        </p>
        <div style="text-align: center">
            <p><span class="bold">Главное медицинское управление Управления делами
                Президента Российской Федерации</span> <br>
                Адрес: 103132, Москва, Никитников переулок, д.2, п.5 <br>
                Телефон: 8(495)606-35-63; факс: 8(495)606-30-06
            </p>
        </div>
        <div style="text-align: center">
            <p><span class="bold">Федеральный орган исполнительной власти, осуществляющий <br>
                функции по контролю и надзору в сфере здравоохранения:</span> <br>
                Адрес: 109074 г.Москва, Славянская площадь, д.4, стр.1 <br>
                Телефон: 8(495)698-45-38; 8(499)578-02-30
            </p>
        </div>
        <div style="text-align: center">
            <p><span class="bold">Территориальный орган, осуществляющий функции <br>
                по контролю и надзору в сфере здравоохранения:</span> <br>
                Адрес: 127206, г.Москва, ул.Вучетича, д.12А <br>
                Телефон: 8(495)611-47-74
            </p>
        </div>
        <div style="text-align: center">
            <p><span class="bold">Федеральный орган исполнительной власти, осуществляющий федеральный <br>
                государственный надзор в области защиты прав потребителей</span> <br>
                Адрес: 127994, г.Москва, Вадковский переулок, д.18, стр.5 и 7 <br>
                Телефон: 8(499)973-26-90
            </p>
        </div>
        <div style="text-align: center">
            <p><span class="bold">Территориальный орган Роспотребнадзора:</span> <br>
                Адрес: 129626, г.Москва, Графский переулок, д.4/9 <br>
                Телефон: 8(495)621-70-76
            </p>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
    padding: 5px 0 5px 150px;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.link > span {
    font-size: 14px;
    border-bottom: 1px dotted #006688;
}

.left-30px {
    margin-left: 30px;
}

.left-100px {
    margin-left: 100px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

@media only screen and (max-width: 1000px) {
    .flex {
        padding: 5px 0;
    }
}
</style>


